<template>
  <div class="jisaoDetail">
    <div class="img">
      <img v-if="info.tombPhoto" :src="info.tombPhoto" />
      <img v-else-if="info.oweArea.areaPhoto" :src="info.oweArea.areaPhoto" />
      <img v-else src="@/assets/jisao.jpg" />
    </div>
    <div v-if="info.id" class="number">
      <span>{{ info.id }}</span>
      <span>{{ info.oweArea.areaName }}{{ info.tombNum }}</span>
    </div>
    <div v-if="info && info.members && info.members.length > 0" class="itemList" >
      <div class="item">
        <!-- <div class="listImg">
          <img src="@/assets/hua.jpg" />
        </div> -->
        <div class="listContent">
          <div class="itemWrap" v-for="(item, index) in info.members" :key="index">
            <div><span>姓名：</span>{{ item.userName }}</div>
            <div><span class="right">性别：</span>{{ item.userGender }}</div>
          </div>
           <div class="itemWrap" style="height:15px;"></div>
          <div class="itemWrap">
            <div><span>墓穴：</span>{{ info.oweStele.steleName }}</div>
            <div><span class="right">期限：</span>永久</div>
          </div>
          <div class="itemWrap">
            <div><span>持证人：</span>{{ info.ownUser }}</div>
          </div>
          <div class="itemWrap">
            <span>管理费到期时间：</span>{{ dateFormat1(info.expiryDate) }}
          </div>
        </div>
      </div>
    </div>
    <div class="btnDiv">
      <div class="btn" @click="goShopjisao(info['id'])">代我祭扫</div>
      <div class="btn" style="margin-left:20px;" @click="goJiniantang(info['id'])">创建纪念堂</div>
    </div>
    <div class="jnt">
      免费创建纪念馆 云端祭祀 指尖寄情 永久保存
    </div>
    <div class="jnttxt">
      友情提示：{{info.reminder}}
    </div>
    <copyright></copyright>
    <div class="kefu">
      <i class="iconfont">&#xec2e;</i
      ><a href="https://work.weixin.qq.com/kfid/kfc10fd463b85635b1b" style="color:#fff;">客服</a>
    </div>
    <div class="zhuanfa"><i class="iconfont">&#xe656;</i>转发亲友</div>
  </div>
</template>

<script>
import copyright from './Copyright'
export default {
  name: 'jisaoDist',
  components: {
    copyright,
  },
  data() {
    return {
      id: 0,
      info: {},
      list: [
        // {
        //   id: 1,
        //   number: '123',
        //   paihao: '龙东区 1排 1号',
        //   name: '张三',
        //   xingbie: '男',
        //   type: '天祥',
        //   qixian: '永久',
        //   daoqi: '2022-12-12',
        // },
        // {
        //   id: 2,
        //   number: '',
        //   paihao: '龙东区 1排 2号',
        //   name: '李四',
        //   xingbie: '男',
        //   type: '天祥',
        //   qixian: '永久',
        //   daoqi: '2022-12-12',
        // },
      ],
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path.indexOf('jnt/create') > -1 || from.path.indexOf('shopjisao') > -1) {
      localStorage.setItem('reload', 'true')
    } else {
      localStorage.removeItem('reload')
    }
    next()
  },
  created() {
    if (localStorage.getItem('reload')) {
      location.reload()
    }
  },
  mounted() {
    var params = this.$route.params
    this.id = params['id']
    this.queryTombOne(this.id)
  },
  methods: {
    dateFormat1(dat) {
      var str = ['']
      if (dat && dat.indexOf(' ') > -1) {
        str = dat.split(' ')
      }
      return str[0]
    },
    dateFormat(dat) {
      var date = new Date(dat)
      var year = date.getFullYear()
      var mon = (date.getMonth()+1) < 10 ? "0"+(date.getMonth()+1) : date.getMonth()+1
      var data = date.getDate()  < 10 ? "0"+(date.getDate()) : date.getDate()
      var newDate = year + "-" + mon + "-" + data
      return newDate
    },
    queryTombOne(id) {
      var that = this
      this.$queryOne(
        '/api/memtomb/queryTombOne',
        { id: id },
        function(res) {
          if(res['data']['members']){
            res['data']['members'] = JSON.parse(res['data']['members'])
          }
          that.info = res['data']
          console.log(JSON.stringify(that.info))
          // that.list.push({
          //   id: 1,
          //   firstPhoto: that.info['firstPhoto'],
          //   number: that.info['tombCode'],
          //   type: that.info['tombHole'],
          //   paihao: that.info['areaName'] + that.info['areaRow'] + '排' + that.info['areaCol'] + '号',
          //   name: that.info['firstName'],
          //   xingbie: that.info['firstGender']['label'],
          //   qixian: that.info['estateYear'],
          //   daoqi: that.info['estateDate'],
          // })
          // if (that.info['tombCount']['value'] == '2') {
          //   that.list.push({
          //     id: 2,
          //     firstPhoto: that.info['firstPhoto'],
          //     number: that.info['tombCode'],
          //     type: that.info['tombHole'],
          //     paihao: that.info['areaName'] + that.info['areaRow'] + '排' + that.info['areaCol'] + '号',
          //     name: that.info['secondName'],
          //     xingbie: that.info['secondGender']['label'],
          //     qixian: that.info['estateYear'],
          //     daoqi: that.info['estateDate'],
          //   })
          // }
        }
      )
    },
    goShopjisao(id) {
      return this.$router.push({ path: '/shopjisao/' + id })
    },
    goJiniantang(id) {
      this.$router.push({ path: '/jnt/create?id=' + id})
    },
  },
}
</script>

<style>
.jisaoDetail .right {
  margin-left: 25px;
}
.jisaoDetail .btnDiv {
  text-align: center;
  width: 100%;
}
.jisaoDetail .btn {
  border-radius: 2500px;
  color: #fff;
  background-image: none;
  background-color: #73c7a0;
  position: relative;
  border: 0px;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 15px;
  font-size: 14px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  text-decoration: none;
  overflow: visible;
  margin-left: 5px;
  -webkit-transform: translate(0px, 0px);
  transform: translate(0px, 0px);
  margin-right: 0;
  width: 40%;
}
.jisaoDetail .zhuanfa {
  background: rgb(116, 199, 160);
  width: 110px;
  border-top-left-radius: 2500px;
  border-bottom-left-radius: 2500px;
  color: #fff;
  text-align: center;
  height: 35px;
  line-height: 35px;
  position: fixed;
  right: 0;
  top: 130px;
}
.jisaoDetail .zhuanfa i {
  margin-right: 5px;
}

.jisaoDetail .kefu {
  background: rgb(116, 199, 160);
  width: 80px;
  border-top-left-radius: 2500px;
  border-bottom-left-radius: 2500px;
  color: #fff;
  text-align: center;
  height: 35px;
  line-height: 35px;
  position: fixed;
  right: 0;
  top: 80px;
}
.jisaoDetail .kefu i {
  margin-right: 5px;
}
.jisaoDetail .img {
  padding: 20px 10px;
}
.jisaoDetail .img img {
  width: 100%;
}
.jisaoDetail .number {
  line-height: 30px;
  text-align: center;
  margin: 0px 0;
  padding: 15px 20px;
  border-bottom: 1px solid #ccc;
  text-align: left;
  position: relative;
  font-size: 16px;
}
.jisaoDetail .number span {
  position: absolute;
  top: -10px;
}
.jisaoDetail .number span:nth-child(1) {
  font-weight: bold;
  left: 20px;
}
.jisaoDetail .number span:nth-child(2) {
  right: 20px;
}
.jisaoDetail .listContent {
  flex: 1;
}
.jisaoDetail .listImg {
  width: 30%;
}
.jisaoDetail .listImg img {
  opacity: 0.6;
  width: 55%;
  margin: 0 auto;
  display: block;
  margin-top: 2%;
}
.jisaoDetail .listContent {
}
.itemList {
  padding: 0 10px;
}
.jisaoDetail .item {
  display: flex;
  background: rgb(245, 245, 245);
  border-radius: 5px;
  margin: 20px auto;
  padding: 0px 0;
  line-height: 25px;
  width: 100%;
}
.jisaoDetail .itemWrap {
  position: relative;
  height: 25px;
  line-height: 35px;
  width: 100%;
}
.jisaoDetail .itemWrap div:nth-child(1) {
  position: absolute;
  left: 0;
  top: 0;
  text-align: left;
  width: 55%;
}
.jisaoDetail .itemWrap div:nth-child(2) {
  position: absolute;
  right: 0;
  top: 0;
  text-align: left;
  width: 45%;
}
.jisaoDetail .jnt {
  padding: 0 20px;
  text-align: right;
  line-height: 25px;
  color: #73c7a0;
  margin: 15px 0;
}
.jisaoDetail .jnttxt {
  padding: 0 20px;
  line-height: 25px;
  color: #bbb;
  margin: 15px 0;
}
</style>
